import { Component, ChangeDetectionStrategy, HostBinding, AfterViewInit, inject } from '@angular/core';
import { ProgressIndicatorComponent } from '@knorr-bremse-portals/ngx-components/components/progress-indicator';

import { OneTrustService } from '../../../app/providers/one-trust.service';

@Component({
  selector: 'app-one-trust-cookie-list',
  templateUrl: './one-trust-cookie-list.component.html',
  styleUrls: ['./one-trust-cookie-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ ProgressIndicatorComponent ],
})
export class OneTrustCookieListComponent implements AfterViewInit {

  @HostBinding('id') private readonly id = 'ot-sdk-cookie-policy';

  private oneTrustService = inject(OneTrustService);

  public ngAfterViewInit(): void {
    this.oneTrustService.renderButtonAndList();
  }

}
